<template>
    <span class="instrucao"
        style="font-size: 14px; color: #212236; margin-bottom: 15px; display: flex; align-items: center;"><img
            src="https://site-inove-bd2fd-homol.web.app/assets/icons/info.svg" alt="" style="margin-right: 10px;"> A
        nota final
        para aprovação deve ser 7 ou superior.</span>
    <div class="finalizado-content">
        <div class="img-background">
            <img src="https://site-inove-bd2fd-homol.web.app/assets/icons/ellipse.svg" alt="img">
        </div>
        <div class="modal-status-finalizado">
            <h1>Avaliação Final</h1>
            <p>Teste de Conhecimento</p>
            <p><strong>Total de questões:</strong> {{ resultado.totalQuestoes }}</p>
            <div class="duracao-prova-final">
                <p><strong><img src="https://site-inove-bd2fd-homol.web.app/assets/icons/calendar-check-green.svg"
                            alt="" width="21px" height="21px">Início:{{ resultado.inicio }}</strong> </p>
                <p><strong><img src="https://site-inove-bd2fd-homol.web.app/assets/icons/calendar-blocked-green.svg"
                            alt="" width="21px" height="21px">Finalizado:{{ resultado.fim }}</strong> </p>
            </div>
            <div class="status-aprovacao">
                <p style="font-size: 20px;">Resultado</p>
                <p style="font-size: 48px; margin-bottom: 30px; color: #212236;"><strong>Nota {{ resultado.totalAcertos
                        }}/10</strong></p>
                <p class="status-aprovacao-p">
                    <span :class="resultado.totalAcertos >= 7 ? 'aprovado' : 'reprovado'">
                        {{ resultado.totalAcertos >= 7 ? "Aprovado" : "Reprovado" }}
                    </span>
                </p>
            </div>
            <div class="buttons-final">
                <button @click="tentarNovamente" :disabled="tentativas >= maxTentativas">
                    Tentar novamente
                </button>
                <button @click="conferirProva">Conferir prova</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tentativas: {
            type: Number,
            required: true,
        },
        maxTentativas: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            resultado: {
                inicio: null,
                fim: null,
                totalQuestoes: 0,
                totalAcertos: 0,
            },
        };
    },
    mounted() {
        const resultadoProva = sessionStorage.getItem("resultadoProva");
        if (resultadoProva) {
            this.resultado = JSON.parse(resultadoProva);
        }
    },
    methods: {
        tentarNovamente() {
            if (this.tentativas < this.maxTentativas) {
                this.$emit("increment-tentativas"); // Notifica o App.vue para atualizar as tentativas
                this.$emit("reset-timer"); // Reseta o timer
                sessionStorage.setItem("currentPage", "prova");
                sessionStorage.removeItem("resultadoProva");
                this.$parent.currentPage = "prova"; // Navega para a página da prova
            } else {
                alert("Você já atingiu o limite máximo de tentativas.");
            }
        },
        conferirProva() {
            this.$emit("review-prova"); // Emite o evento para revisão
        },
    },
};
</script>

<style scoped>
.instrucao {
    display: flex;
    justify-content: end;
    align-items: center;
}

.finalizado-content {
    padding: 15px;
    background: #212236;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.modal-status-finalizado {
    background: #fff;
    border-radius: 7px;
    width: 585px;
    height: 548px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 9;
}

.modal-status-finalizado h1 {
    font-size: 32px;
    color: #212529;
    font-weight: bold;
}

.duracao-prova-final {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin-bottom: 10px;
}

.duracao-prova-final p {
    font-size: 14px;
    margin-bottom: 0;
    padding: 5px;
}

.status-aprovacao {
    background: #16f9b91a;
    width: 100%;
    position: relative;
    margin-bottom: 5%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.status-aprovacao-p {
    background: #212236;
    color: #16f9b9;
    position: absolute;
    padding: 10px;
    border-radius: 8px;
    bottom: -37px;
}

.buttons-final {
    display: flex;
}

.buttons-final button {
    margin: 10px;
}

button:first-child {
    background: #69f9de;
}

button {
    background: #16f9b9;
    border: none;
    padding: 10px;
    padding-inline: 15px;
    border-radius: 7px;
    font-weight: bold;
    margin-top: 10px;
}

button:hover {
    background: #69f9de;
}

@media screen and (min-width:769px) {
    .finalizado-content {
        border-radius: 8px;
        min-height: 94vh;
        background-size: 450px;
        background-repeat: no-repeat;
        background-position-y: center;
        background-position-x: 2.25rem;
        background-image: url(https://site-inove-bd2fd-homol.web.app/media/bg-i9-OZLZTTSZ.png);
        padding: 100px;
    }

    .img-background {
        position: absolute;
        top: 20px;
        right: 295px;
    }
}

@media(max-width:768px) {
    .img-background {
        display: none;
    }
}
</style>